/**
 * Formato español para datos: punto de miles, coma decimal, € detrás con espacio,
 * fechas dd/mm/aaaa. Todo dato se pinta después en Roboto Mono.
 */
const nf = (min: number, max: number) => new Intl.NumberFormat('es-ES', { minimumFractionDigits: min, maximumFractionDigits: max, useGrouping: true });

/** 1284500 → "1.284.500". Fuerza agrupación también en cifras de 4 dígitos. */
export function fmtNumero(n: number, decimales = 0): string {
  return agrupar(nf(decimales, decimales).format(n));
}

/** 1284500 → "1.284.500,00 €" */
export function fmtEuro(n: number, decimales = 2): string {
  return `${fmtNumero(n, decimales)} €`;
}

/** 31.4 → "31,4 %" */
export function fmtPorcentaje(n: number, decimales = 1): string {
  return `${fmtNumero(n, decimales)} %`;
}

/** Variación con signo: 4.1 → "+4,1 %", -2.3 → "−2,3 %" (signo menos tipográfico). */
export function fmtVariacion(n: number, decimales = 1, unidad = '%'): string {
  const s = n > 0 ? '+' : n < 0 ? '−' : '';
  return `${s}${fmtNumero(Math.abs(n), decimales)}${unidad ? ` ${unidad}` : ''}`;
}

const pad = (x: number) => String(x).padStart(2, '0');

/** Date | ISO → "24/09/2026" */
export function fmtFecha(d: Date | string): string {
  const f = typeof d === 'string' ? new Date(d) : d;
  return `${pad(f.getDate())}/${pad(f.getMonth() + 1)}/${f.getFullYear()}`;
}

/** Date | ISO → "24/09/2026 09:30" */
export function fmtFechaHora(d: Date | string): string {
  const f = typeof d === 'string' ? new Date(d) : d;
  return `${fmtFecha(f)} ${pad(f.getHours())}:${pad(f.getMinutes())}`;
}

/** Intl en es-ES no agrupa números de 4 cifras (1234 → "1234"). El manual sí agrupa. */
function agrupar(s: string): string {
  return s.replace(/^(-?)(\d{1,3})(\d{3})(?=,|$)/, '$1$2.$3');
}
